// Generated from products/analytics/shared/custom/aliveByMistake/index.ts; run analytics generate:site-runtime.
import { aliveByMistakeEventId } from "./eventIds.gen";
import { AliveByMistakeActionPayloadSchema } from "./actions.gen";
import { AliveByMistakeSummaryPayloadSchema } from "./summaries.gen";

/** Project-owned payload registration; generic envelopes compose this registry. */
export const aliveByMistakePayloadSchemas = {
  [aliveByMistakeEventId.action]: AliveByMistakeActionPayloadSchema,
  [aliveByMistakeEventId.summary]: AliveByMistakeSummaryPayloadSchema,
} as const;

export * from "./context.gen";
export * from "./actions.gen";
export * from "./summaries.gen";
export * from "./reports.gen";
export * from "./eventIds.gen";
